import appSettings from '../app-settings.json';
import axios from 'axios';

export class StrRegistrationAPISender {
  constructor() {
    this.axiosInstance = axios.create({
      baseURL: appSettings.strRegistrationApiDomain,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      timeout: 180000, // https://medium.com/@masnun/handling-timeout-in-axios-479269d83c68
    });
    this.place = 'ca-placer-business';
  }

  getCityPath(path) {
    if (!this.place) {
      throw new Error('Place name not known in this get request');
    }
    return `/${this.place}${path}`;
  }

  /**
   * Get request with place in url
   *
   * @param {*} path
   * @param {*} params
   * @param {*} responseType
   */
  async get(path, params, responseType = 'json') {
    const pathWithPlace = this.getCityPath(path);
    return this.axiosInstance.get(pathWithPlace, { params, responseType });
  }

  async post(path, body, responseType = '') {
    const bodyJSON = (body && body.toJSON) ? body.toJSON() : body;
    const pathWithPlace = this.getCityPath(path);
    return this.axiosInstance
      .post(pathWithPlace, bodyJSON, { responseType });
  }

  async upload({ uploadToken, file }) {
    const uploadUrl = appSettings.digifyApiDomain;
    return axios.post(`${uploadUrl}/upload/`, file, {
      params: { upload_token: uploadToken },
      headers: { 'Content-Type': file.type }
    });
  }
}

export const strRegistrationApiSender = new StrRegistrationAPISender();
